import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TixRequestResetPasswordGQL } from '@tix/data-access';
import { of, Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'tix-request-password-reset',
  templateUrl: './request-password-reset.component.html'
})
export class TixRequestPasswordResetComponent implements OnDestroy {
  hasReset = false;
  isLoading = false;

  emailControl = new FormControl('', [Validators.required, Validators.email]);

  subs: Subscription[] = [];

  constructor(
    private requestResetPasswordMutation: TixRequestResetPasswordGQL,
    private snackbar: MatSnackBar,
    private cd: ChangeDetectorRef
  ) {}

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  get canReset() {
    return this.emailControl.dirty && this.emailControl.valid;
  }

  handleSubmit(e: SubmitEvent) {
    e.preventDefault();
    if (!this.canReset || this.hasReset) return;

    this.isLoading = true;

    this.requestResetPasswordMutation
      .mutate({
        email: this.emailControl.value,
        url: window.location.origin + '/auth/reset-password'
      })
      .pipe(
        tap(() => {
          this.isLoading = false;
          this.hasReset = true;

          this.cd.detectChanges();
        }),
        catchError(() => {
          this.isLoading = false;
          this.hasReset = true;

          this.cd.detectChanges();

          return of(null);
        })
      )
      .subscribe();
  }
}
